import { observer } from "mobx-react-lite"
import Value from "pages/content/store/value"
import Tooltip from "../tooltip"
import { InputLabel, MultilneInputWrapper, Textarea, TextareaWrapper } from "./styled"

type Props = {
  label?: string,
  placeholder?: string,
  value: Value,
  defaultValue?: string,
  tooltip?: string
}

const MultilineContentInput = observer(({ label, value, placeholder, defaultValue, tooltip }: Props) => {
  return (
    <MultilneInputWrapper>
      <InputLabel>
        { label }
        <Tooltip title={tooltip} />
      </InputLabel>
      <TextareaWrapper>
        <Textarea 
          placeholder={placeholder} 
          value={value.value} 
          onChange={e => value.set(e.target.value)}
        />
      </TextareaWrapper>
    </MultilneInputWrapper>
  )
})

export default MultilineContentInput